module.exports = __webpack_public_path__ + "img/foot_icon2.37644e9d.png";